import { externalLinks } from '@/config';
import { useAppSelector } from '@/redux/hooks';
import { externalServiceSelectors } from '@/redux/selectors';

const useOpenChat = () => {
  const helpcrunchLoaded = useAppSelector(
    externalServiceSelectors.helpcrunchLoaded,
  );

  const handleOpenChat = () => {
    if (helpcrunchLoaded && window.HelpCrunch) {
      window.HelpCrunch('openChat');
    } else {
      window.open(externalLinks.TELEGRAM_SUPPORT_BOT_URL, '_blank');
    }
  };

  return { handleOpenChat };
};

export default useOpenChat;
